import { render } from "./EditActivityClosure.vue?vue&type=template&id=71b45e92"
import script from "./EditActivityClosure.vue?vue&type=script&lang=js"
export * from "./EditActivityClosure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__